define('CartToQuote.Helper', [
    'underscore'
], function CartToQuoteHelper(
    _
) {
    'use strict';

    var cpqPrefixList = [
        'cpqs', // SuiteApp
        'scpq'  // Netsuite CPQ Configurator Bundle
    ];
    var cpqConfig = {
        optionFields: {
            configData: 'custcol_{CPQ?}_item_opt_config_data',
            mainLnData: 'custcol_{CPQ?}_item_opt_repl_sku'
        }
    };

    var getLineOption = function getLineOption(line, optionId) {
        var lnOption;

        _(cpqPrefixList).each(function eachPrefix(prefix) {
            var cartOptionId = optionId.replace('{CPQ?}', prefix);

            lnOption = lnOption || _(line.options).findWhere({
                cartOptionId: cartOptionId
            });
        });
        return lnOption;
    };
  
    var getLineKey = function getLineKey(line, cpqLineData) {
      if(!cpqLineData){
        return line.internalid;
      }
        var key = line.cpqStatus ? cpqLineData.value.internalid : line.internalid;

        key = _(
            _(JSON.parse(key)).pick('transid', 'productId', 'configId', 'dup')
        ).values().join('|') || key;

        return key;
    };

    return {
        getConst: function getConst(key) {
            var consts = {
                itemToQuoteTitle: 'Add to Quote',
                cartToQuoteTitle: 'Cart to Quote',
                cartToQuoteFragment: 'cart-to-quote',
                cartToQuoteConfirmationFragment: 'cart-to-quote-confirmation'
            };
            return consts[key];
        },

        cartLinesToCpq: function cartLinesToCpq(cartLines) {
            var cpqLines = {};

            _(cartLines).each(function eachLine(ln) {
                var cpqLineData = getLineOption(ln, cpqConfig.optionFields.configData);
                var isCpqMainLn = Boolean(
                    getLineOption(ln, cpqConfig.optionFields.mainLnData)
                );
                var key;

                // We check if this is a CPQ line.
                ln.cpqStatus = Boolean(cpqLineData && cpqLineData.value);

                // We assign a group for the current line.
                key = getLineKey(ln, cpqLineData);
                cpqLines[key] = cpqLines[key] || [];

                // If we already have a main line in the current group, any other will be subitem.
                if (cpqLines[key].length && cpqLines[key][0].cpqLevel === 'item') {
                    ln.cpqLevel = 'subitem';
                } else {
                    ln.cpqLevel = isCpqMainLn || !ln.cpqStatus ? 'item' : 'subitem';
                }

                // We add the main line as the first line of the current group.
                if (ln.cpqLevel === 'item') {
                    cpqLines[key].unshift(ln);
                } else {
                    cpqLines[key].push(ln);
                }
                return ln;
            });

            _(cpqLines).each(function eachLines(lines) {
                // If we didn't find a main line for the current group, we update position 0.
                if (lines[0].cpqLevel !== 'item') {
                    lines[0].cpqLevel = 'item';
                }
                // We set the main line ID as the identifier of all the lines in the group.
                _(lines).each(function eachLine(ln) {
                    _(ln).extend({ cpqGroup: lines[0].internalid });
                });
            });

            return _(
                _(cpqLines).toArray()
            ).flatten();
        }
    };
});
